import {
  PASSWORD_LOWERCASE_REGEX,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_NUMBER_REGEX,
  PASSWORD_SYMBOL_REGEX,
  PASSWORD_UPPERCASE_REGEX,
} from '@klareospace/pharos-lib-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface PasswordRequirement {
  isMet: boolean;
  key: string;
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

export function getPasswordRequirements(password: string): PasswordRequirement[] {
  return [
    { isMet: password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH, key: 'length' },
    { isMet: PASSWORD_UPPERCASE_REGEX.test(password), key: 'uppercase' },
    { isMet: PASSWORD_LOWERCASE_REGEX.test(password), key: 'lowercase' },
    { isMet: PASSWORD_NUMBER_REGEX.test(password), key: 'number' },
    { isMet: PASSWORD_SYMBOL_REGEX.test(password), key: 'symbol' },
  ];
}

export function areAllRequirementsMet(password: string): boolean {
  return getPasswordRequirements(password).every((r) => r.isMet);
}
